export default __webpack_public_path__ + "static/media/Accelerons2015.38dfa4d6.png";